<template>
  <div>
    <b-overlay
      :show="stats === null"
      opacity="0.8"
      spinner-small
      spinner-variant="dark"
    >
      <b-card>
        <div class="row">
          <div
            class="col-12 col-md-4 info-card"
            @click="$router.push({ name: 'all-offers' })"
          >
            <div class="colored --bigger --green">
              {{ $t('pages.dashboards.admin.statistics.offers.title') }}
            </div>
            <h1 class="--bigger">
              {{ stats && stats.offersCount ? stats.offersCount : 0 }}
            </h1>
            <font-awesome-icon
              icon="mail-bulk"
              class="info-icon info-icon--green"
            />
            <div class="row justify-content-center mt-4 percentage">
              <h2 style="width: 100%">
                {{ stats && stats.offerApplyCount ? stats.offerApplyCount : 0 }}
              </h2>
              <div class="colored --green">
                {{ $t('pages.dashboards.admin.statistics.offers.total-candidates') }}
              </div>
            </div>
          </div>
          <div
            class="col-12 col-md-4 info-card"
            @click="$router.push({ name: 'admin-companies'})"
          >
            <div class="colored --bigger --orange">
              {{ $t('pages.dashboards.admin.statistics.companies.title') }}
            </div>
            <h1 class="--bigger">
              {{ stats && stats.companiesCount ? stats.companiesCount : 0 }}
            </h1>
            <font-awesome-icon
              icon="building"
              class="info-icon info-icon--orange"
            />
            <div class="row justify-content-center mt-4 percentage">
              <div class="right">
                <h3>{{ stats && stats.activeCompaniesCount ? stats.activeCompaniesCount : 0 }}</h3>
                <div class="colored --green">
                  {{ $t('pages.dashboards.admin.statistics.companies.confirmed') }}
                </div>
              </div>
              <div class="right">
                <h3>{{ stats && stats.pendingCompaniesCount ? stats.pendingCompaniesCount : 0 }}</h3>
                <div class="colored --orange">
                  {{ $t('pages.dashboards.admin.statistics.companies.pending') }}
                </div>
              </div>
              <div class="left">
                <h3>{{ stats && stats.rejectedCompaniesCount ? stats.rejectedCompaniesCount : 0 }}</h3>
                <div class="colored --red">
                  {{ $t('pages.dashboards.admin.statistics.companies.rejected') }}
                </div>
              </div>
            </div>
          </div>
          <div
            class="col-12 col-md-4 info-card info-card--last"
            @click="$router.push({ name: 'admin-users'})"
          >
            <div class="colored --bigger --red">
              {{ $t('pages.dashboards.admin.statistics.users.title') }}
            </div>
            <h1 class="--bigger">
              {{ stats && stats.usersCount ? stats.usersCount : 0 }}
            </h1>
            <font-awesome-icon
              icon="users"
              class="info-icon"
            />
            <div class="row justify-content-center mt-4 percentage">
              <div class="right">
                <h2>{{ stats && stats.companiesCount ? stats.companiesCount : 0 }}</h2>
                <div class="colored --green">
                  {{ $t('pages.dashboards.admin.statistics.users.companies') }}
                </div>
              </div>
              <div class="left">
                <h2>{{ stats && stats.candidatesCount ? stats.candidatesCount : 0 }}</h2>
                <div class="colored --orange">
                  {{ $t('pages.dashboards.admin.statistics.users.users') }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
export default {
  data() {
    return {
      stats: null
    }
  },
  mounted() {
    this.getStats();
  },
  methods: {
    getStats() {
      this.axios.get('/stats/')
        .then( response => {
          this.stats = response.data;
        })
        .catch();
    }
  }
}
</script>


<style lang="scss" scoped>
  .info-card {
    height: 100%;
    padding: 2rem 0;
    transition: 0.3s ease;
    cursor: pointer;

    &:hover {
      transform: scale(1.05);
    }

    .colored {
      font-size: 0.9rem;

      &.--bigger {
        font-size: 1.2rem;
      }

      &.--red {
        color: #FF7588;
      }

      &.--green {
        color: #16D39A;
      }

      &.--orange {
        color: #FF864A;
      }
    }

    .info-icon {
      font-size: 4.5rem;
      color: rgb(225, 225, 225);
      border-bottom: 5px solid #FF7588;
      width: 4rem;

      &--green {
        border-color: #16D39A;
      }

      &--orange {
        border-color: #FF864A;
      }
    }

    .percentage {
      .right {
        border-right: 1px solid #90A4AE;
      }

      .right,
      .left {
        padding: 0 15px;
      }
    }
  }

  .info-card:not(.info-card--last) {
    border-right: 1px solid #ECEFF1;
  }

  .card {
    border: 0 !important;
    box-shadow: 0 10px 40px 0 rgba(62,57,107,.07), 0 2px 9px 0 rgba(62,57,107,.06);
  }

  .card-body {
    padding: 0;
    background: white;
  }
</style>

